const FAQs = () => {
    const updateFAQHeights = () => {
        document.querySelectorAll('.faqs .faq.active .faq-answer').forEach((content) => {
            content.style.maxHeight = `${content.scrollHeight}px`;
        });
    };

    document.addEventListener('DOMContentLoaded', () => {
        const accordionItems = document.querySelectorAll('.faqs .faq');
        const accordionTitles = document.querySelectorAll('.faqs .faq .faq-question');
        const accordionAnswers = document.querySelectorAll('.faqs .faq .faq-answer');

        // Ensure all answers start collapsed
        accordionAnswers.forEach((answer) => {
            answer.style.maxHeight = '0';
        });

        accordionTitles.forEach((title) => {
            title.addEventListener('click', (event) => {
                const parent = event.currentTarget.parentElement;
                const content = parent.querySelector('.faq-answer');
                const isActive = parent.classList.contains('active');

                if (!content) return;

                if (isActive) {
                    // Collapse the currently active item
                    parent.classList.remove('active');
                    content.style.maxHeight = '0';
                } else {
                    // Expand the clicked item
                    accordionItems.forEach((item) => {
                        const itemContent = item.querySelector('.faq-answer');
                        if (itemContent) {
                            item.classList.remove('active');
                            itemContent.style.maxHeight = '0';
                        }
                    });

                    parent.classList.add('active');
                    content.style.maxHeight = `${content.scrollHeight}px`;
                }
            });
        });
    });

    // Debounce function for resize event
    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    window.addEventListener('resize', debounce(updateFAQHeights, 300));
};

export default FAQs;
